import { UnleashClient } from 'unleash-proxy-client'

import { storageKeys } from '@/enums/storageKeys'
import storage from '@/services/localstorage.service'

import { getUnleashForCDN } from './get-unleash-from-cdn'

export const unleashConfig = {
  url: process.env.VUE_APP_UNLEASH_URL,
  clientKey: process.env.VUE_APP_UNLEASH_TOKEN,
  appName: process.env.VUE_APP_UNLEASH_APP_NAME,
  refreshInterval: 0,
}

export const unleash = new UnleashClient(unleashConfig)

export const unleashFallback = async () => {
  const hasUnleashLocalStorage = storage.get(storageKeys.UNLEASH)

  if (hasUnleashLocalStorage) return

  const features = await getUnleashForCDN()

  storage.set(storageKeys.UNLEASH, features)
}

unleash.on('error', unleashFallback)
